import { Link } from 'react-router-dom'
import Footer from '../components/Footer'

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-cte-blue">404</h1>
          <h2 className="mt-4 text-2xl font-semibold text-cte-black">Page not found</h2>
          <p className="mt-2 text-gray-600">
            The page you're looking for doesn't exist.
          </p>
          <Link
            to="/dashboard"
            className="mt-6 inline-block bg-cte-blue text-white px-6 py-3 rounded-lg hover:bg-cte-blue-dark transition-colors"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
      
      {/* Footer */}
      <div className="bg-white">
        <Footer />
      </div>
    </div>
  )
}
